export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14794.9d1a1f1e.jpg";